// Widget scripts
import cardWidget from './js/widgets/cardWidget.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import hotButtons from './js/widgets/hotButtons.js';
import videoWidget from './js/widgets/videoWidget.js';
import sponsorWidgetContainer from './js/widgets/cssSponsors.js';
import infoCards from './js/widgets/infoCards.js';
import splashPage from './js/widgets/splashPage.js';
// Custom theme scripts
import './js/localjs.js';



// Initialize homepage widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    cardWidget();
    swiperWidget();
    hotButtons();
    sponsorWidgetContainer();
    splashPage();
  });
}

// initialize site-wide widgets

$(document).ready(function() {
  // put footer widgets here
  infoCards();
});



$(window).load(function(){ 
  videoWidget();
});